import { render, staticRenderFns } from "./EventPairsTable.vue?vue&type=template&id=0c165d45&scoped=true"
import script from "./EventPairsTable.vue?vue&type=script&lang=js"
export * from "./EventPairsTable.vue?vue&type=script&lang=js"
import style0 from "./EventPairsTable.vue?vue&type=style&index=0&id=0c165d45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c165d45",
  null
  
)

export default component.exports